import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as qs from 'qs';
import { EcondosQuery } from '@api/model/query';
import { environment } from '@environment';
import { BuildProductBanner, ProductBanner, ProductBannerTopic } from '@api/model/product-banner';

// Campos graváveis enviados ao backend (picture como id do File).
export type SaveProductBannerDTO = Pick<
  ProductBanner,
  | 'title'
  | 'description'
  | 'topics'
  | 'ctaLabel'
  | 'ctaLink'
  | 'product'
  | 'condoTypes'
  | 'condoSizeMin'
  | 'condoSizeMax'
  | 'userTypes'
  | 'position'
  | 'isActive'
> & {
  picture?: string | null;
  whiteLabels?: string[];
  startDate?: string;
  endDate?: string | null;
};

@Injectable({ providedIn: 'root' })
export class ProductBannerService {
  protected endPoint = environment.backendUrl;

  constructor(protected http: HttpClient) {}

  getProductBanners(query: EcondosQuery = {}): Observable<{ count: number; banners: ProductBanner[] }> {
    const params = new HttpParams({ fromString: qs.stringify(query) });
    const options = { headers: new HttpHeaders(), params, observe: 'response' as 'body' };
    return this.http.get(`${this.endPoint}product-banners`, options).pipe(
      map((res: any) => ({
        count: parseInt(res.headers.get('count') || '0', 10),
        banners: (res.body || []).map((banner: any) => BuildProductBanner(banner))
      }))
    );
  }

  getProductBannerById(bannerId: ProductBanner['_id'], query: EcondosQuery = {}): Observable<ProductBanner> {
    const params = new HttpParams({ fromString: qs.stringify(query) });
    return this.http.get(`${this.endPoint}product-banners/${bannerId}`, { params }).pipe(map((res: any) => BuildProductBanner(res)));
  }

  getTopics(): Observable<ProductBannerTopic[]> {
    return this.http.get<ProductBannerTopic[]>(`${this.endPoint}product-banners/topics`);
  }

  createProductBanner(data: SaveProductBannerDTO) {
    return this.http.post<{ _id: string }>(`${this.endPoint}product-banners`, data);
  }

  updateProductBanner(bannerId: ProductBanner['_id'], data: SaveProductBannerDTO) {
    return this.http.put(`${this.endPoint}product-banners/${bannerId}`, data);
  }

  deleteProductBanner(bannerId: ProductBanner['_id']) {
    return this.http.delete(`${this.endPoint}product-banners/${bannerId}`);
  }
}
